<!-- hasta aca los cambios -->
<template>
    <v-container fluid class="cbc-analyzer-container">
        <!-- Barra de encabezado con datos del usuario -->
        <v-app-bar app color="white" dark>
            <v-img src="../../images/fishbone-logo.jpg" :min-width="isMobile ? 100 : 900" class="mr-4 logo"></v-img>


            <template v-if="isMobile">
                <v-btn icon @click="showPatientInfo = !showPatientInfo">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>

            <!-- En dispositivos grandes, los datos del usuario y los botones son visibles en el encabezado -->
            <template v-else>
                <v-spacer></v-spacer>

                <v-select v-model="selectedGender" :label="$t('DatosP.genero')" :items="genders" class="mr-3" outlined
                    dense :disabled="true"></v-select>
                <v-text-field v-model="age" :label="$t('DatosP.edad')" class="mr-3" outlined dense
                    :disabled="true"></v-text-field>
                <v-text-field v-model="weight" :label="$t('DatosP.peso')" class="mr-3" outlined dense
                    :disabled="true"></v-text-field>
                <v-text-field v-model="height" :label="$t('DatosP.estatura')" class="mr-3" outlined dense
                    :disabled="true"></v-text-field>
                <v-select v-model="selectedEthnicity" :items="ethnicities" :label="$t('DatosP.etnia')" outlined dense
                    :disabled="true"></v-select>
                <v-btn :href="'/'" color="primary" class="mr-3">
                    <v-icon left>mdi-logout</v-icon>
                    {{ $t('app.logout') }}
                </v-btn>
                <v-btn :href="`/usuarios/editar/${this.idUsuario}`" color="primary" class="mr-3">
                    <v-icon left>mdi-logout</v-icon>
                    {{ $t('app.actualizar') }}
                </v-btn>

                <v-btn v-if="rol === 2" :href="'/maestros'" color="primary" class="mr-3">
                    <v-icon left>mdi-logout</v-icon>
                    {{ $t('app.maestroParametros') }}
                </v-btn>
                <v-btn v-if="rol === 2" :href="'/DesEnfermedades'" color="primary" class="mr-3">
                    <v-icon left>mdi-logout</v-icon>
                    {{ $t('app.maestroEnfermedades') }}
                </v-btn>
            </template>
        </v-app-bar>

        <!-- Navegación lateral para dispositivos móviles -->
        <v-navigation-drawer v-model="showPatientInfo" temporary right>
            <v-list>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="title">{{ $t('app.datosPaciente') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Campos de datos -->
                <v-list-item>
                    <v-select v-model="selectedGender" :items="genders" :label="$t('DatosP.genero')" outlined dense
                        :disabled="true" />
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="age" :label="$t('DatosP.edad')" outlined dense :disabled="true" />
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="weight" :label="$t('DatosP.peso')" outlined dense :disabled="true" />
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="height" :label="$t('DatosP.estatura')" outlined dense :disabled="true" />
                </v-list-item>
                <v-list-item>
                    <v-select v-model="selectedEthnicity" :items="ethnicities" :label="$t('DatosP.etnia')" outlined
                        dense :disabled="true" />
                </v-list-item>

                <!-- Botones también dentro del drawer -->
                <v-divider class="my-2" />
                <v-list-item>
                    <v-btn :href="'/'" color="primary" block>
                        <v-icon left>mdi-logout</v-icon>
                        {{ $t('app.logout') }}
                    </v-btn>
                </v-list-item>
                <v-list-item v-if="rol === 2">
                    <v-btn :href="'/maestros'" color="primary" block>
                        <v-icon left>mdi-logout</v-icon>
                        {{ $t('app.maestroParametros') }}
                    </v-btn>
                </v-list-item>
                <v-list-item v-if="rol === 2">
                    <v-btn :href="'/DesEnfermedades'" color="primary" block>
                        <v-icon left>mdi-logout</v-icon>
                        {{ $t('app.maestroEnfermedades') }}
                    </v-btn>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>


        <!-- Cuerpo Principal -->
        <v-row class="mt-5">
            <!-- Publicidad Izquierda (Visible solo en pantallas grandes) -->
            <v-col cols="12" sm="1" class="advertisement left-ad" v-if="!isMobile">
            </v-col>

            <!-- Panel Principal -->
            <v-col :cols="isMobile ? 12 : 10">
                <v-row style="margin: 0;" class="flex-container">
                    <!-- Izquierda 70% -->
                    <v-col :cols="isMobile ? 12 : 7" class="principal">

                        <v-card class="analyzer-card" style="border-radius: 4em;">
                            <v-card-title class="text-center"
                                style="font-size:3em; font-family:Georgia, 'Times New Roman', Times, serif;">{{
                                    $t('app.enzimas') }}</v-card-title>
                            <!-- Fishbone Analyzer Diagram -->

                            <div class="fishbone-container">
                                <v-row class="mt-4" align="center" :justify="isMobile ? 'end' : 'start'">
                                    <v-col cols="auto">
                                        <v-btn @click="realizarcalculo" class="fishbone-input btn">
                                            Diagnosis
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-text-field v-model="fields.ast" label="AST" outlined dense
                                    class="fishbone-input ast"></v-text-field>
                                <v-text-field v-model="fields.alt" label="ALT" outlined dense
                                    class="fishbone-input alt"></v-text-field>
                                <v-text-field v-model="fields.alp" label="ALP" outlined dense
                                    class="fishbone-input alp"></v-text-field>
                                <v-text-field v-model="fields.albumin" label="Albumina" outlined dense
                                    class="fishbone-input albumin"></v-text-field>
                                <v-text-field v-model="fields.ldh" label="LDH" outlined dense
                                    class="fishbone-input ldh"></v-text-field>
                                <v-text-field v-model="fields.tbr" label="Tot Bilirubin" outlined dense
                                    class="fishbone-input tbr"></v-text-field>
                                <v-text-field v-model="fields.dbr" label="Dir Bilirubin" outlined dense
                                    class="fishbone-input dbr"></v-text-field>
                                <v-text-field v-model="fields.idr" label="IDR Bilirubin" outlined dense
                                    class="fishbone-input idr"></v-text-field>
                                <v-text-field v-model="fields.tpr" label="Tot Protein" outlined dense
                                    class="fishbone-input tpr"></v-text-field>
                                <v-text-field v-model="fields.gbl" label="Globulin" outlined dense
                                    class="fishbone-input gbl"></v-text-field>

                            </div>
                            <v-btn @click="clearFields" color="brown" class="mt-4" block>
                                {{ $t('app.limpiarcampos') }}
                            </v-btn>

                        </v-card>

                    </v-col>



                    <!-- Derecha 30% -->
                    <v-col :cols="isMobile ? 12 : 5" class="right-panel">
                        <v-card class="data-card" style="max-height:fit-content">
                            <v-card-title class="text-center"
                                style="background-color:transparent; font-size:2.5em ; color: white;">{{
                                    $t('app.diagnostico') }}</v-card-title>
                            <v-row dense style="align-items: center">
                                <v-col cols="12" v-for="(item, index) in additionalData" :key="index">
                                    <v-card class="data-box position-relative" outlined v-if="item.value">

                                        <v-card-actions>
                                            <v-btn text color="primary" @click="openBanner(item.label, item.value)">
                                                {{ $t('app.verdetalles') }}
                                            </v-btn>
                                        </v-card-actions>

                                        <v-card-text :class="item.value === 'Normal' ? 'green-text' : 'red-text'">
                                            {{ $t('app.diagnostico') }} {{ item.label }}: {{ item.value }}
                                        </v-card-text>

                                        <!-- ÍCONO DE ALERTA: solo aparece si NO es normal -->
                                        <v-icon v-if="item.value !== 'Normal'" class="alert-icon" color="yellow"
                                            size="32">
                                            mdi-alert-circle
                                        </v-icon>

                                    </v-card>
                                </v-col>
                            </v-row>

                            <!-- Dialogo para mostrar el "banner" -->
                            <v-dialog v-model="showBanner" max-width="600">
                                <v-card class="banner-card rounded-xl elevation-6 pa-4">
                                    <!-- Título principal -->
                                    <v-card-title class="banner-title text-h5 font-weight-bold pb-2">
                                        {{ selectedLabel }}
                                    </v-card-title>

                                    <v-card-text>
                                        <v-expansion-panels focusable inset>
                                            <v-expansion-panel v-for="(info, i) in bannerData" :key="i"
                                                class="banner-panel">
                                                <v-expansion-panel-header class="banner-panel-header">
                                                    <span class="text-subtitle-1 font-weight-bold">{{ info.title
                                                        }}</span>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="banner-panel-content">
                                                    <v-list dense class="banner-list">
                                                        <v-list-item v-for="(detail, j) in info.details" :key="j"
                                                            class="banner-list-item">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="banner-text">
                                                                    <span class="bullet">•</span> {{ detail }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-card-text>

                                    <v-card-actions class="justify-end">
                                        <v-btn color="primary" variant="flat" class="close-btn"
                                            @click="showBanner = false">
                                            {{ $t('app.cerrar') }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-card class="data-box" outlined v-if="infusionRate">
                                <v-card-text>Tasa de Infusión: {{ infusionRate }}</v-card-text>
                            </v-card>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>

            <!-- Publicidad Derecha (Visible solo en pantallas grandes) -->
            <v-col cols="12" sm="1" class="advertisement right-ad" v-if="!isMobile">
            </v-col>
        </v-row>

        <!-- Publicidad Inferior -->
        <v-row class="advertisement botton-ad mt-4">
            <v-col cols="12">
            </v-col>
        </v-row>
    </v-container>
</template>

<!-- un cambio mas arriba -->
<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
const apiUrl = process.env.VUE_APP_API_URL;


export default {

    setup() {
        const parametros = ref({});
        const cargarParametros = async () => {
            try {
                const response = await axios.get(`${apiUrl}/api/parameters`);

                const data = response.data;
                const parametrosMap = {
                    ast: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    alt: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    alp: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    albumin: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    ldh: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    tbr: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    dbr: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    idr: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    tpr: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    gbl: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' }
                };

                data.forEach((param) => {
                    const createParamObject = (param) => ({
                        valorMostrado: param.valorMostrado || '',
                        valorAlto: param.valorAlto || '',
                        valorBajo: param.valorBajo || '',
                        units: param.units || '',
                        rango: param.rango || ''
                    });

                    switch (param.parametro.toLowerCase()) {
                        case 'ast':
                            parametrosMap.ast = createParamObject(param);
                            break;
                        case 'alt':
                            parametrosMap.alt = createParamObject(param);
                            break;
                        case 'alp':
                            parametrosMap.alp = createParamObject(param);
                            break;
                        case 'albumin':
                            parametrosMap.albumin = createParamObject(param);
                            break;
                        case 'ldh':
                            parametrosMap.ldh = createParamObject(param);
                            break;
                        case 'tbr':
                            parametrosMap.tbr = createParamObject(param);
                            break;
                        case 'dbr':
                            parametrosMap.dbr = createParamObject(param);
                            break;
                        case 'idr':
                            parametrosMap.idr = createParamObject(param);
                            break;
                        case 'tpr':
                            parametrosMap.tpr = createParamObject(param);
                            break;
                        case 'gbl':
                            parametrosMap.gbl = createParamObject(param);
                            break;
                        // Aquí puedes agregar más casos si tienes más parámetros.
                    }
                });

                parametros.value = parametrosMap;


                localStorage.setItem('parametros', JSON.stringify(parametros.value));

            } catch (error) { // Asegúrate de tener el parámetro `error` aquí
                console.error('Error al cargar parámetros:', error);
            }
        };

        onMounted(() => {
            const savedParams = localStorage.getItem('parametros');
            if (savedParams) {
                parametros.value = JSON.parse(savedParams);
            }

            cargarParametros();
        });

        return { parametros };
    },

    data() {
        return {
            showBanner: false, // Estado del banner
            selectedLabel: "", // Etiqueta seleccionada
            bannerData: [], // Información detallada del banner
            showPatientInfo: false,
            aniongap: 0,
            fields: {
                ast: '',
                alt: '',
                alp: '',
                albumin: '',
                ldh: '',
                tbr: '',
                dbr: '',
                idr: '',
                tpr: '',
                gbl: ''
            },
            selectedGender: null,
            age: null,
            weight: null,
            height: null,
            selectedEthnicity: null,

            idUsuario: null,
            idioma: null,

            prbcbcplt: null,
            prbcbcmcv: null,
            diagnosisOne: '',
            diagnosisOneDesc: '',
            diagnosisPlt: '',
            diagnosisPltDesc: '',
            additionalData: [

                { label: 'R Factor', value: '' },
                { label: 'AST', value: '' },
                { label: 'ALT', value: '' },
                { label: 'ALP', value: '' },
                { label: 'Albumin', value: '' },
                { label: 'LDH', value: '' },
                { label: 'Total Billirubin', value: '' },
                { label: 'Direct Bilirubin', value: '' },
                { label: 'Indirect Bilirubin', value: '' },
                { label: 'Total protein', value: '' },
                { label: 'Globulin', value: '' },
                { label: 'Liver Damage', value: '' },
                { label: 'Secundario', value: '' },
                { label: 'Terceario', value: '' },

            ],
            // Variables necesarias para la tasa de infusión
            genderVal: null,
            weightVal: null,
            ageVal: null,
            ivna: null,
            ivk: null,
            naChange: null,
            infusionRate: null, // Para guardar la tasa de infusión calculada
            individualDiagnoses: [], // Nuevo arreglo para guardar diagnósticos individuales

            diagnostico1: '',
            diagnostico2: ''
        };
    },
    computed: {

        isMobile() {
            return this.$vuetify.display.mdAndDown;
        },

        // Lógica para calcular diagnósticos según los valores
        diagnosis() {
            const ast = this.convertToNumber(this.fields.ast);
            const alt = this.convertToNumber(this.fields.alt);
            const alp = this.convertToNumber(this.fields.alp);
            const albumin = this.convertToNumber(this.fields.albumin);
            const ldh = this.convertToNumber(this.fields.ldh);
            const tbr = this.convertToNumber(this.fields.tbr);
            const dbr = this.convertToNumber(this.fields.dbr);
            const idr = this.convertToNumber(this.fields.idr);
            const tpr = this.convertToNumber(this.fields.tpr);
            const gbl = this.convertToNumber(this.fields.gbl);



            if (alt && alp) {
                this.additionalData[0].value = this.evaluatedRfactor(alt, alp);
            }


            this.additionalData[1].value = ast ? this.evaluateast(ast) : '';
            this.additionalData[2].value = alt ? this.evaluatealt(alt) : '';
            this.additionalData[3].value = alp ? this.evaluatealp(alp) : '';
            this.additionalData[4].value = albumin ? this.evaluatealbumin(albumin) : '';
            this.additionalData[5].value = ldh ? this.evaluateldh(ldh) : '';
            this.additionalData[6].value = (tbr || tbr === 0) ? this.evaluatetbr(tbr) : '';
            this.additionalData[7].value = (dbr || dbr === 0) ? this.evaluatedbr(dbr) : '';
            this.additionalData[8].value = (idr || idr === 0) ? this.evaluateidr(idr) : '';
            this.additionalData[9].value = (tpr || tpr === 0) ? this.evaluatetpr(tpr) : '';
            this.additionalData[10].value = (gbl || gbl === 0) ? this.evaluategbl(gbl) : '';

            if (this.prbcbcmcv != null && this.prbcbcplt != "null" && this.prbcbcmcv != '' && this.prbcbcplt != '') {
                this.additionalData[11].value = this.combineddiagnosis()
            }



        }

    },
    methods: {

        clearFields() {
            // Limpiar los campos de texto
            this.fields.ast = '';
            this.fields.alt = '';
            this.fields.alp = '';
            this.fields.albumin = '';
            this.fields.ldh = '';
            this.fields.tbr = '';
            this.fields.dbr = '';
            this.fields.idr = '';
            this.fields.tpr = '';
            this.fields.gbl = '';

            // Limpiar los datos dentro de additionalData
            this.additionalData.forEach(item => {
                if (item.label !== 'Diagnostico Primario' && item.label !== 'Diagnostico Secundario') {
                    item.value = ''; // Limpiar solo los valores de los otros campos
                }
            });

            // Hacer desaparecer "Diagnóstico Primario" y "Diagnóstico Secundario"
            const primary = this.additionalData.find(item => item.label === 'Diagnostico Primario');
            const secondary = this.additionalData.find(item => item.label === 'Diagnostico Secundario');
            if (primary) {
                primary.value = '';
            }
            if (secondary) {
                secondary.value = '';
            }
        },


        openBanner(label, value) {
            this.selectedLabel = label;
            this.showBanner = true;

            axios.get(`${apiUrl}/api/enfermedades/filter?enfermedad=${value}`)
                .then(response => {
                    const enfermedad = response.data[0]; // asumimos que es único

                    if (enfermedad) {
                        this.bannerData = [
                            {
                                title: "Differential Diagnosis",
                                details: enfermedad.descripcion
                                    ? enfermedad.descripcion.split('\n').map(str => str.trim()).filter(Boolean)
                                    : [this.$t('Errores.sinDescripcion')]
                            },
                            {
                                title: "Workup",
                                details: enfermedad.tratamiento
                                    ? enfermedad.tratamiento.split('\n').map(str => str.trim()).filter(Boolean)
                                    : [this.$t('Errores.sinTratamiento')]
                            },
                        ];
                    } else {
                        this.bannerData = [
                            {
                                title: this.$t('Errores.sinInfobd'),
                                details: [this.$t('Errores.sinInfobd')],
                            },
                        ];
                    }
                })
                .catch(error => {
                    console.error(this.$t('Errores.sinDatos'), error);
                    this.bannerData = [
                        {
                            title: "Error",
                            details: [this.$t('Errores.problemabd')],
                        },
                    ];
                });
        },

        fieldLabel(field) {
            const labels = {
                ast: 'ast',
                alt: 'alt',
                alp: 'alp',
                albumin: 'albumin',
                ldh: 'ldh',
                tbr: 'tbr',
                tbr: 'dbr',
                tbr: 'idr',
                tbr: 'tpr',
                tbr: 'gbl'

            };
            return labels[field] || field;
        },

        evaluatedRfactor(alt, alp) {

            if (alt > (1.30 * this.parametros.alt.valorAlto) || alp > (1.30 * this.parametros.alp.valorAlto)) {

                if (alt && alp) {
                    let rfactor = (alt / this.parametros.alt.valorAlto) / (alp / this.parametros.alp.valorAlto)

                    if (rfactor >= 5) {
                        return 'HepatoCellular Injuri'
                    } else if (rfactor <= 2) {
                        return 'Cholestatic Injuri'
                    } else if (rfactor >= 2 && rfactor <= 5) {
                        return 'Mixed HepatoCellular-Cholestatic Injury'
                    }
                }
            } else {
                return "Normal"
            }


        },
        evaluatedRfactorNum(alt, alp) {

            if (alt && alp) {
                let rfactor = (alt / this.parametros.alt.valorAlto) / (alp / this.parametros.alp.valorAlto)
                return rfactor
            }

        },
        addevaluated() {
            const alt = this.convertToNumber(this.fields.alt);
            const alp = this.convertToNumber(this.fields.alp);

            let rfactore
            if (alt && alp) {
                rfactore = this.evaluatedRfactorNum(alt, alp);
                console.log("dede addevaluated Rfactor", rfactore)
            }

            let mensaje = ''
            const valorAlto = this.parametros.alt.valorAlto
            console.log(valorAlto)

            if (alt > (2 * valorAlto) && alt < (5 * valorAlto)) {
                mensaje = "Mild Liver Injury"
            } else if (alt > (5.1 * valorAlto) && alt < (15 * valorAlto)) {
                mensaje = "Moderate Liver Injury"
            } else if (alt > (15 * valorAlto)) {
                mensaje = "Severe Liver Injury"
            } else if (alt > (1000 * valorAlto)) {
                mensaje = "Severe Liver Injury"
            } else {
                mensaje = "No interpretation of liver damage"
            }
            console.log(mensaje)
            this.additionalData[11].value = mensaje;



        },
        combineddiagnosis() {
            const ast = this.convertToNumber(this.fields.ast);
            const alt = this.convertToNumber(this.fields.alt);
            const alp = this.convertToNumber(this.fields.alp);
            const albumin = this.convertToNumber(this.fields.albumin);
            const ldh = this.convertToNumber(this.fields.ldh);
            const tbr = this.convertToNumber(this.fields.tbr);
            const dbr = this.convertToNumber(this.fields.dbr);
            const idr = this.convertToNumber(this.fields.idr);
            const tpr = this.convertToNumber(this.fields.tpr);
            const gbl = this.convertToNumber(this.fields.gbl);
            let mensajeGB1
            let mensajeGB2
            let plt = 900
            let mcv = 79

            if (this.prbcbcmcv > mcv && this.prbcbcplt <= plt) {
                mensajeGB1 = "chronic liver failure, chronic hepatitis B, chronic hepatitis C"
            } else if (this.prbcbcmcv > 80 && this.prbcbcmcv < 100) {
                mensajeGB1 = "possible acute infections  "
            }

            return mensajeGB1
        },

        realizarcalculo() {
            this.addevaluated();
        },


        convertToNumber(value) {
            if (typeof value === 'string' && value.endsWith('K')) {
                return parseInt(value.slice(0, -1)) * 1000;
            }
            return parseFloat(value);
        },
        resetForm() {
            for (let field in this.fields) {
                this.fields[field] = ''; // Reset all fields to empty
            }
        },

        // Métodos de evaluación para cada campo

        evaluateast(ast) {
            if (ast <= this.parametros.ast.valorBajo) return 'AST Low';
            else if (ast >= this.parametros.ast.valorAlto) return 'AST High';
            return 'Normal';
        },
        evaluatealt(alt) {
            if (alt <= this.parametros.alt.valorBajo) return 'ALT Low';
            else if (alt >= this.parametros.alt.valorAlto) return 'ALT High';
            return 'Normal';
        },
        evaluatealp(alp) {

            if (alp >= this.parametros.alp.valorAlto) return 'ALP High';
            else if (alp <= this.parametros.alp.valorBajo) return 'ALP Low';
            return 'Normal';
        },
        evaluatealbumin(albumin) {
            if (albumin >= this.parametros.albumin.valorAlto) return 'albumin High';
            else if (albumin <= this.parametros.albumin.valorBajo) return 'albumin Low';
            return 'Normal';
        },
        evaluateldh(ldh) {
            if (ldh >= this.parametros.ldh.valorAlto) return 'ldh High';
            else if (ldh <= this.parametros.ldh.valorBajo) return 'ldh Low';
            return 'Normal';
        },
        /* a partir de aca abajo no salen, agregarlos */
        evaluatetbr(tbr) {
            if (tbr >= this.parametros.tbr.valorAlto) return 'TBR High';
            else if (tbr <= this.parametros.tbr.valorBajo) return 'TBR Low';
            else if (tbr == 0) return 'Low'
            return 'Normal';
        },
        evaluatedbr(dbr) {
            if (dbr >= this.parametros.dbr.valorAlto) return 'dbr High';
            else if (dbr <= this.parametros.dbr.valorBajo) return 'dbr Low';
            return 'Normal';
        },
        evaluateidr(idr) {
            if (idr >= this.parametros.idr.valorAlto) return 'idr High';
            else if (idr <= this.parametros.idr.valorBajo) return 'idr Low';

            return 'Normal';
        },
        evaluatetpr(tpr) {
            if (tpr >= this.parametros.tpr.valorAlto) return 'TPR High';
            else if (tpr <= this.parametros.tpr.valorBajo) return 'TPR Low';

            return 'Normal';
        },
        evaluategbl(gbl) {
            if (gbl >= this.parametros.gbl.valorAlto) return 'Globulin High';
            else if (gbl <= this.parametros.gbl.valorBajo) return 'Globulin Low';

            return 'Normal';
        },

        teaseBasicInfo() {
            alert('Complete los datos básicos de la persona antes de continuar.');
        }
    },

    watch: {
        fields: {
            handler: async function () {
                this.diagnosis

            },
            deep: true
        }
    },


    mounted() {
        // Asignar valores desde Vuex a las variables del componente
        this.selectedGender = this.$store.state.user.gender;
        this.age = this.$store.state.user.age;
        this.weight = this.$store.state.user.weight;
        this.height = this.$store.state.user.height;
        this.selectedEthnicity = this.$store.state.user.ethnicity;
        this.prbcbcplt = this.$store.state.cbc.plt;
        this.prbcbcmcv = this.$store.state.cbc.mcv
        this.idUsuario = this.$store.state.user.idusuario;
        this.idioma = this.$store.state.user.idioma;
        console.log(this.idioma)
        const savedParams = localStorage.getItem('parametros')
        console.log(this.selectedGender)
        console.log(this.prbcbcmcv, "estas son mcv")
        if (this.prbcbcplt == null || this.prbcbcplt == '') {
            alert(this.$t('Alertas.plt1'));
        }

        if (this.prbcbcmcv == null || this.prbcbcmcv == '') {
            alert(this.$t('Alertas.mvc'));
        }
    }

};

</script>

<style scoped>
.green-text {
    color: darkgreen;
}

.red-text {
    color: red;
}

.position-relative {
    position: relative;
}

.alert-icon {
    position: absolute;
    bottom: 8px;
    right: 8px;
}

/* Tarjeta principal */
.banner-card {
    background: linear-gradient(145deg, #f9fafb, #f1f5f9);
    border: 1px solid #e2e8f0;
}

/* Título */
.banner-title {
    color: #1e293b;
    border-bottom: 2px solid #3b82f6;
    padding-bottom: 0.5rem;
}

/* Panel */
.banner-panel {
    margin-bottom: 8px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e5e7eb;
}

/* Header del panel */
.banner-panel-header {
    background-color: #f3f4f6;
    font-weight: bold;
    color: #334155;
}

/* Contenido con fondo */
.banner-panel-content {
    background: linear-gradient(135deg, #eef2ff, #f8fafc);
    padding: 0.75rem;
    border-left: 4px solid #3b82f6;
    /* Franja azul decorativa */
}

/* Lista */
.banner-list {
    padding-left: 0.5rem;
}

.banner-list-item {
    transition: background-color 0.2s ease;
    border-radius: 6px;
}

.banner-list-item:hover {
    background-color: #f1f5f9;
}

/* Texto */
.banner-text {
    font-weight: 500;
    /* un poco más grueso */
    color: #1e293b;
}

/* Bullet */
.bullet {
    color: #3b82f6;
    font-size: 1.2rem;
    margin-right: 6px;
}

/* Botón cerrar */
.close-btn {
    text-transform: none;
    font-weight: 600;
}

.botton-ad {
    background-image: url('../../images/bajamicro.jpg');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.right-ad {
    background-image: url('../../images/izquierda.avif');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.left-ad {
    background-image: url('../../images/izquierda.avif');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.banner-card {
    background-image: url('../../images/abg.jpg');
    background-size: cover;
    background-position: center;
    color: white;
}

.banner-overlay {
    background-color: rgba(255, 255, 255, 0.8);
    padding: 16px;
    border-radius: 8px;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.principal {
    flex: 1 0 140px;

}

.right-panel {
    background-color: transparent;
    flex: 1 0 120px;
}






/* Fondo completo para la página */
.cbc-analyzer-container {
    background-image: url('../../images/plantillacafe.jpg');
    background-size: cover;
    /* Hace que la imagen de fondo cubra todo el área */
    background-position: center;
    /* Centra la imagen */
    min-height: 100vh;
    /* Hace que la altura mínima sea el 100% de la pantalla */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}



/* Estilos generales de la interfaz */
.cbc-analyzer-container {
    background-color: #f0f0f0;
}

.advertisement {
    background-color: #d3d3d3;
    /*     opacity: 0.2; */
    min-height: 2em;
    text-align: center;
}

.analyzer-card {
    background-color: transparent;
    color: white;
    padding: 20px;


}

/* Estilos del diagrama tipo fishbone */
.fishbone-container {
    position: relative;
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: #00aaff; */
    background-image: url('../../images/analyzer_liver.png');
    background-size: 100%;
    background-position: center 100%;
    background-repeat: no-repeat;
    border-radius: 1em;
}

.fishbone-input {
    position: absolute;
    /* width: 80px; */
    text-align: center;
    background-color: white;
    color: grey;
    border-radius: 5%;
    font-weight: 900;
    max-height: 3em;
    min-width: 5.5em;
}

.data-box {
    background-color: white;
    /* Fondo blanco */
    border-radius: 12px;
    /* Bordes redondeados */
    border: 1px solid #374b40;
    /* Borde azul claro */
    margin-bottom: 10px;
    /* Separación entre los cuadros */
    padding: 10px;
    text-align: center;
    max-width: 25em;
    align-items: center
}

/* Estilo para el texto dentro de los cuadros */
.diagnosis-text {
    color: #00aaff;
    /* Color de texto celeste */
    font-weight: bold;
    /* Texto en negrita */
    font-size: 1.2rem;
    /* Aumentar tamaño de la fuente */
}

/* Contenedor donde se encuentra la imagen */
.fishbone-container {
    position: relative;
    width: 100%;
    height: 400px;
    /* Mantén un tamaño adecuado o ajusta */
    background-color: #d0a84af5;
    /* Opcional, para que puedas ver el área de la imagen */
}

/* Estilo de la imagen */
.analyzer-background {
    position: absolute;
    top: -60px;
    /* La imagen comienza en la parte superior */
    left: 45%;
    /* Centrado horizontalmente */
    transform: translateX(-50%);
    /* Asegura que esté completamente centrada */
    width: 100%;
    /* O puedes ajustar el ancho según sea necesario */
    height: auto;
    /* Mantiene las proporciones de la imagen */
}

.data-card {
    background-color: transparent;
    /* Fondo semi-transparente */
}

/* Media Queries para pantallas más pequeñas */
/* Media Queries para pantallas más pequeñas */
@media(min-width:900px) {

    /* Posicionamiento de cada cuadro de entrada en el diagrama */
    .ast {
        top: 10%;
        left: 35%;
    }

    .alt {
        top: 10%;
        left: 54%;
    }

    .alp {
        top: 30%;
        left: 35%;
    }

    .albumin {
        top: 30%;
        left: 54%;
    }

    .ldh {
        top: 55%;
        Left: 35%;
    }

    .tbr {
        top: 55%;
        left: 54%;
    }

    .dbr {
        top: 10%;
        left: 20%;
    }

    .idr {
        top: 30%;
        left: 20%;
    }

    .tpr {
        top: 55%;
        left: 20%;
    }

    .gbl {
        top: 55%;
        left: 70%;
    }

    .btn {
        top: 1%;
        left: 75%;
        /* background-color: #a58524; */
        background-color: rgb(115, 77, 12);
        /* Color naranja suave */
        border-radius: 20px;
        /* Redondeo de las esquinas */
        color: white;
        /* Color de texto blanco */
        padding: 10px 20px;
        /* Espaciado interno para hacer el botón más grande */
        border: none;
        /* Elimina el borde predeterminado */
        cursor: pointer;
        /* Cambia el cursor a mano al pasar sobre el botón */
        transition: background-color 0.3s ease;
        /* Transición suave en el cambio de color */
    }

    .btn:hover {
        background-color: #FF7F32;
        /* Un naranja más oscuro para el hover */
    }




}

@media (max-width: 900px) {
    .fishbone-container {
        background-image: none;
        /* Solo oculta la imagen de fondo, no el contenedor */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        height: auto;
        flex-wrap: wrap;
        gap: 8px;

    }

    .fishbone-input {
        position: relative;
        width: 90%;
        margin: 5px 0;
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
    }


    .flex-container {
        display: flex;
        flex-direction: column;
        /* Cambia a columna */
        align-items: center;
    }

    .principal {
        width: 100%;
    }

    .right-panel {
        width: 100%;
    }

    .advertisement.left-ad {
        order: -1;
        /* Coloca la publicidad izquierda arriba */
    }

    .advertisement.right-ad {
        order: 2;
        /* Coloca la publicidad derecha abajo */
    }

    .logo {
        width: 100px;
        /* Hace el logo más pequeño en pantallas pequeñas */
        margin-left: 0;
        margin-right: auto;
    }

    .advertisement h1 {
        font-size: 1.5em;
        /* Reduce el tamaño del texto en la publicidad */
    }

    .data-card {
        padding: 15px;
    }

    .diagnosis-text {
        font-size: 1rem;
        /* Ajusta el tamaño del texto de diagnóstico */
    }

    .data-box {
        font-size: 0.9em;
        /* Ajusta el tamaño de las cajas de datos */
    }

    .analyzer-card {
        padding: 10px;
    }
}
</style>